import {PriceRule} from '@app/models/price-rule';

export function isPriceRuleActive(p: PriceRule, now: Date) {
    return p.isActive && p.season.end >= now;
}

export function isPriceRuleActiveBetween(p: PriceRule, from: Date, to: Date) {
    return p.isActive && p.season.start <= from && to <= p.season.end;
}





